<template>
    <form ref="form"
          action="/"
          method="post"
          class="search-panel__filter-form">
        <div class="search-panel__form-fieldset">
            <div class="search-panel__filter-item"
                    v-for="(filter, index) in filters"
                    :key="index">
                <template v-if="isCheckboxFilter(filter.type)">
                    <div class="mini-chooser__filter mini-chooser__buttons-group">
                        <CheckboxItem v-for="(item, index) in filter.items"
                            modify="checkbox_theme_button"
                            :key="index"
                            :name="`${filter.category}[${item.id}]`"
                            :value="`${item.id}`"
                            :title="item.title"
                            :checked="item.checked"
                            :disabled="item.disabled"
                            @change="emitSend"
                        />
                    </div>
                </template>
                <template v-if="isSliderFilter(filter.type)">
                    <div class="mini-chooser__filter">
                        <RangeSlider :slider="filter"
                                     :changed="priceChange"
                                     @change="emitSend"/>
                    </div>
                </template>
            </div>
        </div>
        <ResultButton v-if="!isEmpty(link)"
                      :link="link"
                      :windowWidth="windowWidth" />
    </form>
</template>

<script>

import CheckboxItem from '../CheckboxItem/CheckboxItem.vue';
import RangeSlider from '../RangeSlider/RangeSlider.vue';
import ResultButton from '../ResultButton/ResultButton.vue';
import Utils from '../../../common/scripts/utils';

export default {
    props: ['data', 'isCollapsed', 'isMobile', 'isPanelOpen', 'priceChange', 'windowWidth'],

    data() {
        return {
            isFixed: false
        };
    },

    components: {
        CheckboxItem,
        RangeSlider,
        ResultButton
    },

    computed: {
        filters() {
            return this.data.filters || null;
        },

        link() {
            return this.data.links || null;
        }
    },

    watch: {
        isPanelOpen() {
            if (this.isPanelOpen) {
                if (this.isMobile) {
                    Utils.bodyFixed(this.$refs.filterWrapper);
                    this.isFixed = true;
                } else if (this.isFixed) {
                    Utils.bodyStatic();
                }
            } else if (this.isMobile) {
                Utils.bodyStatic();
                this.isFixed = false;
            }
        },

        isMobile() {
            if (this.isFixed) {
                Utils.bodyStatic();
                this.isFixed = false;
            }
        }
    },

    methods: {
        toggleFilter() {
            if (this.isPanelOpen) {
                this.closeFilter();
            } else {
                this.openFilter();
            }
        },

        openFilter() {
            this.$emit('openFilter');
        },

        closeFilter() {
            this.$emit('closeFilter');
        },

        /**
         * При изменении фильтра,
         * отправляем данные на бэк
         * @param {Boolean} isTypeChanged - изменился ли тип помещений
         */
        emitSend(isTypeChanged = false) {
            this.$emit('changeFilter', this.$refs.form, isTypeChanged, this.priceChanged);
        },

        /**
         * Проверяет объект на пустоту
         * @param {Object} obj - проверяемый объект
         * @return {boolean|boolean} - true, если пустой
         */
        isEmpty(obj) {
            if (!obj) {
                return true;
            }

            return Object.keys(obj).length === 0 && obj.constructor === Object;
        },

        isCheckboxFilter(type) {
            return type === 'checkbox';
        },

        isSliderFilter(type) {
            return type === 'slider';
        },

        isSelectFilter(type) {
            return type === 'select';
        }
    }
};
</script>
